<template>
<section class="main">
    <nav class="nav ft-body-3-1 bottom-line">

        <dl class="contact-section1">
            <dt class="ft-body-2-1">联系我们</dt>

            <dd>
                <span class="op-trk-event">
                    全国热线：400-9627-818
                </span>

            </dd>

            <dd>
                <span class="op-trk-event company-address">
                    公司地址：北京市丰台区芳城园一区17号日月天地B座2607
                </span>
            </dd>

            <!-- <div class="cp-plus-minus-btns">
                <svg class="op-icon plus-btn">
                    <use xlink:href="#icon-plus"></use>
                </svg>
                <svg class="op-icon minus-btn">
                    <use xlink:href="#icon-minus"></use>
                </svg>
            </div> -->
        </dl>
        <!-- style="margin-right: 40px;width: 210px;" -->
        <dl class="contact-section2">
            <dt class="ft-body-2-1">渠道合作</dt>

            <dd>
                <span class="op-trk-event">联系人：陆先生</span>
            </dd>
            <dd>
                <span class="op-trk-event">联系电话：18611272737</span>
            </dd>

            <!-- <div class="cp-plus-minus-btns">
                <svg class="op-icon plus-btn">
                    <use xlink:href="#icon-plus"></use>
                </svg>
                <svg class="op-icon minus-btn">
                    <use xlink:href="#icon-minus"></use>
                </svg>
            </div> -->
        </dl>
        <dl class="contact-section3">
            <dt class="ft-body-2-1">定制服务</dt>

            <dd>
                <span class="op-trk-event">联系人：张先生</span>
            </dd>
            <dd>
                <span class="op-trk-event">联系电话：13466656569</span>
            </dd>

            <!-- <div class="cp-plus-minus-btns">
                <svg class="op-icon plus-btn">
                    <use xlink:href="#icon-plus"></use>
                </svg>
                <svg class="op-icon minus-btn">
                    <use xlink:href="#icon-minus"></use>
                </svg>
            </div> -->
        </dl>

        <dl class="qr-section">

            <dd>
                <div class="clearfix text-right footer-servies">

                    <div class="contact_info">
                        <img src="../assets/18091680880645_.pic.jpg">
                        <!--<div class="text-center">E尚网小程序</div>-->
                    </div>
                    <div class="contact_info">
                        <img src="../assets/18101680880697_.pic_thumb.jpg">
                        <!--<div class="text-center">E尚网公众号</div>-->
                    </div>
                </div>

            </dd>

            <!-- <div class="cp-plus-minus-btns">
                <svg class="op-icon plus-btn">
                    <use xlink:href="#icon-plus"></use>
                </svg>
                <svg class="op-icon minus-btn">
                    <use xlink:href="#icon-minus"></use>
                </svg>
            </div> -->
        </dl>

    </nav>
</section>
<section class="bottom">
    <ul class="links ft-body-3">
        
        <li class="rights">
            <a href="https://beian.miit.gov.cn/" target="_blank">© 2017 - 2026 北京云软在线通信技术有限公司 版权所有</a>
            <a href="https://beian.miit.gov.cn" target="_blank">  京ICP备18007938号-1</a>
        </li>
        <div class="back-to-top" @click="scrollToTop">
        <span>返回顶部▲</span>
    </div>
    </ul>
</section>
</template>

<script>
export default {
  methods: {
    scrollToTop() {
      // 平滑滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      
      // 或者使用锚点方式（兼容性更好）
      // document.documentElement.scrollTop = 0;
      // document.body.scrollTop = 0;
    }
  }
}
</script>

<style>
.text-right {
    display: flex;
    text-align: right;
}

.contact_info {
    display: inline-block;
    vertical-align: top;
    margin-right: 20px;
    color: #999;
}

.text-left {
    text-align: left;
}

.contact_info>img {
    width: 120px;
}

.text-center {
    text-align: center !important;
}

.company_adress {
    margin-top: 25px;
    padding-right: 10px;
    float: right;
}

.company_adress img {
    vertical-align: top;
    margin: 2px 0 0 8px;
}

.company_adress span {
    display: inline-block;
    font-size: 14px;
    color: #999;
    margin-left: 8px;
    vertical-align: top;
    letter-spacing: 1px;
}

#footer .main nav dl {
    margin-right: 40px;
    width: 210px;
}

.contact-section1 {
    margin-right: 40px;
    min-width: 380px; /* 增加宽度 */
    flex: 1;
    max-width: 430px;
}

.contact-section2 {
    margin-right: 40px;
    min-width: 200px; /* 增加宽度 */
    flex: 1;
    max-width: 250px;
}

.contact-section3 {
    margin-right: 40px;
    min-width: 200px; /* 增加宽度 */
    flex: 1;
    max-width: 250px;
}


.company-address {
    white-space: nowrap; /* 防止换行 */
    overflow: hidden;
    text-overflow: ellipsis; /* 如果文字过长，显示省略号 */
    display: block;
    max-width: 100%;
}

@media screen and (max-width: 767.98px) {
    #footer .main nav dl {
        max-height: 256px;
        width: auto;
    }

    #footer .main nav dl dd {
        height: auto;
    }
}

.back-to-top {
  position: absolute;
  right: 20px;             /* 距离右边距离，可调 */
  bottom: 20px;            /* 距离底部距离，可调 */
  cursor: pointer;
  color: #666;
  font-size: 14px;
  z-index: 10;
  /* 可选：让它更像按钮 */
  /* background: rgba(0,0,0,0.5); */
  /* color: white; */
  /* padding: 8px 12px; */
  /* border-radius: 4px; */
}

.back-to-top:hover {
  color: #000;
  /* text-decoration: underline; */
}
</style>
